import { buildFormFetchURL } from './urlReader';

export const getSchema = async (queryParams: ObjectKeyStringKeyValues) => {
  const config: RequestInit = {
    credentials: 'same-origin'
  };

  const url = buildFormFetchURL(queryParams);
  const fetchResponse = await fetch(url, config);

  if (!fetchResponse.ok) {
    const textResponse = await fetchResponse.text();
    throw Error(textResponse);
  }

  return await fetchResponse.json();
};

export const getAsyncFieldValidation = async (
  validationUrl: string,
  urlParams: ObjectKeyStringKeyValues
) => {
  const formattedParams = new URLSearchParams(urlParams);
  return fetch(`${validationUrl}?${formattedParams.toString()}`);
};

export const submitForm = async (
  submitEndpoint: string,
  values: ObjectKeyStringKeyValues
) => {
  const requestBody = {
    ...values
  };

  const config: RequestInit = {
    method: 'POST',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json'
    }
  };

  const response = await fetch(submitEndpoint, config);

  if (!response.ok) {
    throw Error('An error has occurred please check response');
  }

  return await response.json();
};
